import React, { useEffect } from "react";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import ManageOwners from "../../components/generic/ManageOwners";
import {fetchBranchById, manageBranchOwner} from "../../store/branch-slice";
import {fetchUserList} from "../../store/list-slice";

const BranchManageOwners = () => {
    const navigate = useNavigate();
    const params = useParams();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchUserList());
    }, [dispatch]);

    useEffect(() => {
        dispatch(fetchBranchById(params.branchId)); // Adjust based on your actual Redux action
    }, [dispatch, params.branchId]);


    const list = useSelector(state => state.list);

    const {
        items,
        fetchByIdStatus,
        manageOwnerStatus,
    } = useSelector(state => state.branch);

    const branch = fetchByIdStatus === "success" && items.find(item => item.id === params.branchId);
    const existingOwners = branch?.users?.Owner?.map(owner => ({
        user: owner.id,
        percentage: owner.stakePercentage
    })) || [];

    useEffect(() => {
        if (manageOwnerStatus === "success") {
            navigate("../..");
        }
    }, [manageOwnerStatus, navigate]);

    const handleFormSubmit = (data) => {
        dispatch(manageBranchOwner({ id: params.branchId, owners: data }));
    }

    return (
        <>
            <SubHeader title="Manage branch owners">
                <Button to="../../" className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>

            <div className="container p-0 ms-0">
                <div className="row">
                    <ManageOwners onFromSubmit={handleFormSubmit} list={list} existingOwners={existingOwners}/>
                </div>
            </div>
        </>
    );
};

export default BranchManageOwners;
